window.addEventListener('DOMContentLoaded', () => {
    jQuery('.checkout-left, .checkout-right').theiaStickySidebar({
        additionalMarginTop: 50,
    });
});
